import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { Operation } from "src/app/shared/types/entity.type";
import { AuthenticationService } from "../../../../core/authentication/authentication.service";
import { LoadingService } from "../../../../core/loader/loading.service";
import { DynamicFormComponent } from "../../../../shared/components/dynamic-form/dynamic-form.component";
import { QuestionBase } from "../../../../shared/components/dynamic-form/question-base";
import { NotificationService } from "../../../../shared/components/notification/notification.service";
import { UserInfo } from "../../../../shared/types/user-info";
import { isRequiredField } from "../../../../shared/utils/helpers/common.helper";
import { PartnerService } from "../partner.service";
import { Partner } from "../partner.type";
import { CreatePartnerService } from "./create-partner.service";

@Component({
  selector: "app-create-partner",
  templateUrl: "./create-partner.component.html",
  styleUrls: ["./create-partner.component.css"],
  providers: [CreatePartnerService],
})
export class CreatePartnerComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;

  loading = false;
  public isRequiredField = isRequiredField;
  currentUser: UserInfo;
  questions: QuestionBase<string | boolean>[];
  operation: Operation;

  constructor(
    private partnerService: PartnerService,
    private loader: LoadingService,
    private notificationService: NotificationService,
    private router: Router,
    public location: Location,
    private authenticationService: AuthenticationService,
    private questionsService: CreatePartnerService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
    this.operation = Operation.create;
  }

  ngOnInit(): void {
    const options = {
      disablePartnerId: false,
      showIsResellerNeeded: true,
      operation: this.operation,
    };
    this.questionsService.generateQuestions(options).subscribe((qs) => {
      this.questions = qs;
    });
  }

  goBack(): void {
    this.location.back();
  }

  navigateToBulkMode(): void {
    this.router.navigate(["/partners/bulk-upload"]);
  }

  onSubmit(partner: Partner): void {
    this.loader.show();
    if (partner.logo) {
      partner.logo = partner.logo.split(",")[1];
    } else {
      delete partner.logo;
    }

    this.partnerService
      .createPartner(partner)
      .pipe(finalize(() => this.dynamicForm.enable()))
      .subscribe(
        (_partner: Partner) => {
          this.notificationService.success("partner has been created");
          this.router.navigate([`/partners/${_partner.id}`]);
        },
        (err) => this.notificationService.error(err),
      )
      .add(() => {
        this.loader.hide();
      });
  }
}
